import React, { useState, useEffect } from 'react';
import AboutSection from './components/AboutSection';
import ModelsSection from './components/ModelsSection';
// import BlogSection from './components/BlogSection';
import JobsSection, { jobs, JobModal } from './components/JobsSection';
import Confidential from './pages/Confidential';
import DemoLanding from './pages/landing/DemoLanding';
import JobsPage from './pages/JobsPage';

function App() {
    const [path, setPath] = useState(window.location.pathname);

    useEffect(() => {
        function handleLocation() {
            setPath(window.location.pathname);
            window.scrollTo(0, 0);
        }
        window.addEventListener('popstate', handleLocation);
        return () => window.removeEventListener('popstate', handleLocation);
    }, []);

    useEffect(() => {
        if (window.location.hash) {
            const el = document.getElementById(window.location.hash.slice(1));
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
    });

    if (path === '/demo') {
        return <DemoLanding />;
    }

    if (path === '/confidential') {
        return <Confidential />;
    }

    if (path === '/jobs' || path.startsWith('/jobs/')) {
        return <JobsPage path={path} navigate={setPath} />;
    }

    const jobMatch = path.startsWith('/jobs/') ? jobs.find(j => j.slug === path.replace('/jobs/', '')) : null;

    function goHome() {
        window.history.pushState({}, '', '/');
        setPath('/');
        window.scrollTo(0, 0);
    }

    return (
        <div className="relative text-[#26251e] font-serif selection:bg-stone-200">
            {/* Fixed Video Background */}
            <video
                autoPlay
                loop
                muted
                playsInline
                className="fixed bottom-0 left-0 w-full h-[500px] object-cover -z-10"
            >
                <source src="/footer.mp4" type="video/mp4" />
            </video>

            {/* Dark Overlay - Fixed with Video */}
            <div className="fixed bottom-0 left-0 w-full h-[500px] bg-black/70 mix-blend-multiply -z-[5]"></div>

            {/* Fixed Footer Text */}
            <div className="fixed bottom-0 left-0 w-full h-[500px] flex flex-col justify-between px-8 md:px-16 pt-12 pb-20 -z-[4]">
                <div></div>
                <div className="text-white">
                    <h2 className="text-4xl md:text-6xl font-serif">Canopy Labs</h2>
                </div>
                <div className="text-white text-sm md:text-base font-sans">
                </div>
            </div>

            {/* White Content Area */}
            <div className="bg-white">
                {jobMatch ? (
                    <JobModal job={jobMatch} onClose={goHome} />
                ) : (
                    <div className="max-w-[44rem] mx-auto px-6 pt-24 pb-16 md:px-0 md:pt-32 md:pb-16">
                        <AboutSection />
                        <ModelsSection />
                        {/* <BlogSection /> */}
                        <section className="relative mb-16">
                            <div className="md:absolute md:left-[calc(-50vw+22rem)] md:top-0 md:w-[calc(50vw-22rem)] md:text-center mb-6 md:mb-0">
                                <h2 className="text-base font-medium text-[#777777] lowercase">jobs</h2>
                            </div>
                            <a
                                href="/jobs"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.history.pushState({}, '', '/jobs');
                                    window.dispatchEvent(new PopStateEvent('popstate'));
                                }}
                                className="group flex items-center justify-between py-2 cursor-pointer"
                            >
                                <span className="text-base font-medium text-[#1C1C1C] group-hover:text-[#FB651F] transition-colors">View open roles</span>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-[#FB651F]">
                                    <path d="M2.4 12H20M20 12L13 5M20 12L13 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                        </section>
                    </div>
                )}
            </div>

            {/* Transparent Footer Area - Shows fixed video behind */}
            <footer className="relative w-full min-h-[400px] bg-transparent">
            </footer>
        </div>
    );
}

export default App;
